export default __webpack_public_path__ + "static/causa-global-diabetes-e2ffb51966a3e3898ab50fd6a0fa727c.png";